'use strict';

var _      = require('underscore');
var $      = require('jquery');
var Core   = require('../core/core.js');
var TopNav = require('../topnav/topnav.js');
var Dashboard = require('../dashboard/dashboard.js');
var Sidebar = require('../sidebar/sidebar.js');
var Tab    = require('../tab/tab.js');

/**
 * Creates a Master Layout
 *
 * @param {String} [options.target=body]
 * @class
 */
 
class Master extends Core {

    _defaults() {
        return {
            target: 'body',
            fields: {
                'noNav': ""
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div>
                <% if(!noNav) { %><div class='editor__master__topnav js-editor__master__topnav'></div><%}%>
                <div class='editor__master__content js-editor__master__content'>
                    <div class='editor__master__content__tabs js-editor__master__tabs'></div>
                </div>
            </div>
        `;

        super.render();

        //fit to full screen in view mode
        if(options.fields['noNav']) $('.editor__master__content').css('top', '0px');
    }

    /**
     * Adds a menu to this layout
     * @returns {TopNav}
     */
    addTopNav(logo_link, logo_img){
        return new TopNav({
            target: $(".js-editor__master__topnav", this.$el),
            fields: {
                'menu_logo': {
                    'img': logo_img,
                    'link': logo_link
                }
            }
        });
    }

    /**
     * Adds a tab to this layout
     * @returns {Tab}
     */

    addTab(){
        return new Tab({
            target: $(".js-editor__master__tabs", this.$el)
        });
    }

    /**
     * Adds a sidebar
     * @returns {Tab}
     */

    addSidebar(pos, width, theme){
        return new Sidebar({
            target: $(".js-editor__master__content", this.$el),
            prepend: true,
            fields: {
                'position': pos,
                'width': width,
                'theme': theme
            }
        });
    }


}
module.exports = Master;
